import { types } from "mobx-state-tree";
import * as actions from './IntegrationActions';
import * as views from './IntegrationViews';

const Integration = types
  .model('Integration', {
    id: types.identifierNumber,
    provider: types.maybeNull(types.string), // e.g., "TREEZ"
    type: types.maybeNull(types.string), // e.g., "POS"
    status: types.maybeNull(types.string), // e.g., "DISABLED", "ENABLED"
    name: types.maybeNull(types.string),
    merchantId: types.maybeNull(types.number),
    syncOrders: types.maybeNull(types.boolean),
    syncProducts: types.maybeNull(types.boolean),
    syncStock: types.maybeNull(types.boolean), // Added based on EditIntegrationModal
    apiKey: types.maybeNull(types.string),
    clientId: types.maybeNull(types.string),
    partnerId: types.maybeNull(types.string),
    dispensaryName: types.maybeNull(types.string),
    createdAt: types.maybeNull(types.string),
    updatedAt: types.maybeNull(types.string),
  })
  .views(views.integrationViews)
  .actions(actions.integrationActions);

export default Integration;
